import React, {Component} from 'react';
import {connect} from "react-redux";
import {withTranslation} from 'react-i18next';
import {avatarFileUpload} from "../../actions/actions";
import Tabs from 'react-bootstrap/Tabs';
import Tab from 'react-bootstrap/Tab';
import {changeAutoAssignment} from "../../actions/actions";
import {saveChatLimitForAgent} from "../../actions/actions";

@connect((store) => {
    return {
        chatprop: store.chatprop
    };
})
class AgentSidebar extends Component {

    constructor(props) {
        super(props);
        this.state = {
            isToggleAvatar: false,
        };
        this.handleClick = this.handleClick.bind(this);
        this.openAvatarUpload = this.openAvatarUpload.bind(this);
        this.setUploadAvatar = this.setUploadAvatar.bind(this);
        this.changeAutoAssignment = this.changeAutoAssignment.bind(this);
        this.chooseAvatar = this.chooseAvatar.bind(this);
        this.amountMinus = this.amountMinus.bind(this);
        this.amountPlus = this.amountPlus.bind(this);
        this.saveChatLimitButton = this.saveChatLimitButton.bind(this);

        this.amountValue = React.createRef();



    }

    handleClick(e) {
        this.setState({isToggleAvatar: !this.state.isToggleAvatar});
    }

    saveChatLimitButton(e,id){

        this.props.dispatch(saveChatLimitForAgent({
            id:id,
            amount:parseInt(this.amountValue.current.value)
        }));
        e.preventDefault();
    }
    amountPlus(e){
        e.preventDefault();
        var amounts=parseInt(this.amountValue.current.value);
        if(amounts>9999){
            amounts=9999;
            this.amountValue.current.value=amounts;
        } else{
            if(isNaN(amounts)){
                amounts=1;
            }else{
                amounts=amounts+1;
            }
            this.amountValue.current.value=amounts;
        }
    }
    amountMinus(e){
        e.preventDefault();
        var amounts=parseInt(this.amountValue.current.value);

        if(amounts>1){
            amounts=amounts-1;
            this.amountValue.current.value=amounts;
        }

    }
    openAvatarUpload(e) {
        this.avatarUploadInput.click();
    }

    chooseAvatar(e, id) {
        this.props.dispatch({
            type: 'SET_MODAL',
            data: {
                "show": true,
                "page": "chooseAvatar",
                "data": {
                    id: id
                }
            }
        });
        e.preventDefault();
    }

    setUploadAvatar(e, id) {
        var file = this.avatarUploadInput.files[0];
        this.props.dispatch(avatarFileUpload(file, id));

    }

    changeAutoAssignment(e, id) {
        this.props.dispatch(changeAutoAssignment(id, e.target.checked));
    }

    componentDidMount() {
    }

    render() {
        const {t} = this.props;


        return (
            <div>
                {this.props.chatprop.allAgents.filter(agent => agent.id == this.props.agent_id)
                    .map((filteredAgent, index) => {

                        return <div className="left-sidebar-wrap sidebar active slimscroll">
                            <div className="settings-option">
                                <a href="#" className="user-list-item">Edit Settings</a>
                            </div>
                            <div className="profile-card">
                                <div className="profile-cover text-center mb-3 ">
                                    <div className="dropdown">
                                        <div className="profile-cover-avatar " htmlFor="avatar_upload">
                                            <div className="avatar mr-0  avatar-img"
                                                 style={{width: "100%", height: "100%"}}>
                                                <div className="letter-avatar agentAvatar"
                                                     style={{width: "100%", height: "100%", borderRadius: "50%"}}>
                                                    {filteredAgent.no_avatar == 1 &&
                                                    <span>{filteredAgent.first_letter}</span>
                                                    }
                                                    {filteredAgent.no_avatar == 0 &&
                                                    <span><img src={filteredAgent.avatar}/></span>
                                                    }

                                                </div>
                                            </div>
                                            <div className="avatar-edit" onClick={this.handleClick.bind(this)}>
                                                <i className="bx bxs-edit"></i>
                                                <div className="dropdown-livechat">
                                                    <input className="avatar-file-upload"
                                                           ref={input => this.avatarUploadInput = input}
                                                           style={{display: "none"}}
                                                           type="file"
                                                           name="avatar_file"
                                                           onChange={e => this.setUploadAvatar(e, filteredAgent.id)}

                                                           accept="image/*"/>
                                                    <div id="editAvatarDropdown" className="dropdown-livechat-content"
                                                         style={{display: this.state.isToggleAvatar ? 'block' : 'none'}}>
                                                        <a href="#" className="avatar-upload-button"
                                                           onClick={this.openAvatarUpload.bind(this)}>Upload your
                                                            own</a>
                                                        <a href="#"
                                                           onClick={e => this.chooseAvatar(e, filteredAgent.id)}
                                                        >Choose from gallery</a>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <h5 className="mt-3 profile-name mb-1">{filteredAgent.username}</h5>
                                    <p className="profile-email mb-1">{filteredAgent.email}</p>
                                    <h5 className="profile-country mb-0">{filteredAgent.phone_number}</h5>
                                </div>
                                <div className="about-media-tabs">
                                    <nav>
                                        <Tabs defaultActiveKey="general" className="filter-tab">
                                            <Tab eventKey="general" title="General">
                                                <div className="member-details">
                                                    <ul>
                                                        <li>
                                                            {filteredAgent.state == 1 &&
                                                            <span className="badge badge-success">Active User</span>
                                                            }
                                                            {filteredAgent.state == 2 &&
                                                            <span
                                                                className="badge badge-warning">Account Suspended</span>
                                                            }
                                                            {filteredAgent.state == 3 &&
                                                            <span className="badge badge-error">Deleted</span>
                                                            }
                                                        </li>
                                                        <li>
                                                            <h6>Status</h6>
                                                            {filteredAgent.away == 1 &&
                                                            <span className="badge badge-warning">Away</span>
                                                            }
                                                            {filteredAgent.away == 0 && filteredAgent.status == 0 &&
                                                            <span className="badge badge-danger">Offline</span>
                                                            }
                                                            {filteredAgent.away == 0 && filteredAgent.status == 1 &&
                                                            <span className="badge badge-success">Online</span>
                                                            }
                                                        </li>
                                                        <li>
                                                            <h6>Role</h6>
                                                            {filteredAgent.role == 1 &&
                                                            <span className="badge badge-danger">Owner</span>
                                                            }
                                                            {filteredAgent.role == 2 &&
                                                            <span className="badge badge-warning">Administrator</span>
                                                            }
                                                            {filteredAgent.role == 3 &&
                                                            <span className="badge badge-primary">Agent</span>
                                                            }
                                                        </li>

                                                    </ul>
                                                </div>
                                                <div className="settings-col">
                                                    <h6>Settings</h6>
                                                    <ul>
                                                        <li className="d-flex align-items-center">
                                                            <label className="switch">
                                                                <input class="auto_assignment_change" type="checkbox"
                                                                       checked={filteredAgent.auto_assignment == 1 ? true : false}
                                                                       onChange={e => this.changeAutoAssignment(e, filteredAgent.id)}/>
                                                                <span className="slider round"></span>
                                                            </label>
                                                            <div>
                                                                <span>Automatic Assignment</span>
                                                            </div>
                                                        </li>

                                                    </ul>
                                                </div>
                                                <div className="settings-col">
                                                    <h6>Chat Limit</h6>
                                                    <ul>
                                                        <li>
                                                            <div className="quantity">
                                                                <button
                                                                    type="button"
                                                                    className="amountMinus"
                                                                    onClick={e=>this.amountMinus(e)}
                                                                >
                                                                    <i className="bx bx-minus"></i>
                                                                </button>
                                                                <input type="text"
                                                                       ref={this.amountValue}
                                                                       className="text-center amountValue"
                                                                       disabled
                                                                       value={filteredAgent.chat_limit}/>
                                                                <button type="button"
                                                                        onClick={e=>this.amountPlus(e)}
                                                                        className="amountPlus"
                                                                ><i className="bx bx-plus"></i>
                                                                </button>

                                                            </div>
                                                            <div>
                                                                <button
                                                                    className="saveChatLimitButton"
                                                                    onClick={e=>this.saveChatLimitButton(e,filteredAgent.id)}
                                                                    title="Update"
                                                                ><i
                                                                    className="bx bx-refresh"></i></button>
                                                            </div>
                                                        </li>

                                                    </ul>

                                                </div>
                                            </Tab>
                                            <Tab eventKey="department" title="Department">
                                                <div className="participants-list">
                                                    <ul className="user-list mt-2">
                                                        {Object.keys(filteredAgent.departments).map((dep) => {
                                                            return <li className="d-flex">
                                                                <div
                                                                    className="users-list-body d-flex justify-content-between">
                                                                    <div>
                                                                        <h5>{filteredAgent.departments[dep]}</h5>
                                                                    </div>

                                                                </div>
                                                            </li>
                                                        })}
                                                    </ul>

                                                </div>

                                            </Tab>

                                        </Tabs>
                                    </nav>
                                </div>
                            </div>

                        </div>
                    })}
            </div>
        )

    }
}

export default withTranslation()(AgentSidebar);
